// Sanitize a server-supplied SVG string before injecting it via
// dangerouslySetInnerHTML (audit M6). The QR SVGs we render are generated
// server-side today, but inline SVG can carry <script>/onload handlers, so we
// strip anything executable as defense-in-depth. Uses the browser's own
// parser (no extra dependency); returns "" if the input doesn't parse.
export function sanitizeSvg(svg: string): string {
  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    // SSR / non-browser: refuse to emit unsanitised markup.
    return "";
  }
  try {
    const doc = new DOMParser().parseFromString(svg, "image/svg+xml");
    const root = doc.documentElement;
    if (!root || root.nodeName.toLowerCase() === "parsererror" || root.nodeName.toLowerCase() !== "svg") {
      return "";
    }

    const scrub = (el: Element) => {
      // Strip event handlers and unsafe href targets on this element.
      for (const attr of Array.from(el.attributes)) {
        const name = attr.name.toLowerCase();
        const value = attr.value.trim().toLowerCase();
        if (name.startsWith("on")) {
          el.removeAttribute(attr.name);
        } else if (name === "href" || name === "xlink:href") {
          // Only allow internal fragment refs and inline data-image refs.
          if (!value.startsWith("#") && !value.startsWith("data:image/")) {
            el.removeAttribute(attr.name);
          }
        } else if ((name === "style" || name === "src") && value.includes("javascript:")) {
          el.removeAttribute(attr.name);
        }
      }
      // Recurse, removing executable / foreign content entirely.
      for (const child of Array.from(el.children)) {
        const tag = child.tagName.toLowerCase();
        if (tag === "script" || tag === "foreignobject" || tag === "iframe") {
          child.remove();
          continue;
        }
        scrub(child);
      }
    };

    scrub(root);
    return new XMLSerializer().serializeToString(root);
  } catch {
    return "";
  }
}
